import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { canEditData } from '@repo/shared/common';
import { ensureRouteInfiniteData } from '~/lib/query';
import { currentOrganizationQueryOptions } from '~/lib/queries/organization';
import { uploadsListInfiniteQueryOptions } from '~/features/upload/use-uploads';
import { UploadHistoryPage } from '~/features/upload/UploadHistoryPage';

export const Route = createFileRoute('/_protected/uploads/')({
  // Viewer guard: the uploader is an edit-only surface. Read the (cache-warm,
  // seeded by _protected) current-org role and bounce viewers to /unauthorized
  // before the loader runs.
  beforeLoad: async ({ context }) => {
    const { role } = await context.queryClient.ensureQueryData(
      currentOrganizationQueryOptions(),
    );
    if (role === null || !canEditData(role)) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  // The list defines the page, so await it on the server: the first paint shows
  // the real state (rows or the empty state) instead of flashing a skeleton to
  // empty. On a client navigation this prefetches (non-blocking) — the table
  // shows a skeleton while it lands.
  loader: ({ context }) =>
    ensureRouteInfiniteData(context.queryClient, uploadsListInfiniteQueryOptions()),
  component: UploadsIndexRoute,
});

function UploadsIndexRoute(): ReactNode {
  return <UploadHistoryPage />;
}
